import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "doAnswerPage" }
const _hoisted_2 = { style: {"margin-bottom":"16px"} }
const _hoisted_3 = { style: {"margin-top":"24px"} }

import {
  computed,
  reactive,
  ref,
  watchEffect,
} from "vue";
import API from "@/api";
import { useRouter } from "vue-router";
import { listQuestionVoByPageUsingPost } from "@/api/questionController";
import message from "@arco-design/web-vue/es/message";
import { getAppVoByIdUsingGet } from "@/api/appController";
import {addUserAnswerUsingPost, generateUserAnswerIdUsingGet} from "@/api/userAnswerController";

interface Props {
  appId: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DoAnswerPage',
  props: {
    appId: { default: () => {
    return "";
  } }
  },
  setup(__props: any) {

const props = __props;

const router = useRouter();

const app = ref<API.AppVO>({});
// 题目内容结构（理解为题目列表）
const questionContent = ref<API.QuestionContentDTO[]>([]);

// 当前题目的序号（从 1 开始）
const current = ref(1);
// 当前题目
const currentQuestion = ref<API.QuestionContentDTO>({});
// 当前题目选项
const questionOptions = computed(() => {
  return currentQuestion.value?.options
    ? currentQuestion.value.options.map((option) => {
        return {
          label: `${option.key}. ${option.value}`,
          value: option.key,
        };
      })
    : [];
});
// 当前答案
const currentAnswer = ref<string>();
// 回答列表
const answerList = reactive<string[]>([]);
// 是否正在提交结果
const submitting = ref(false);

// 唯一id
const uuid = ref<number>();

// 生成唯一id
const generateUUID = async () => {
  const res = await generateUserAnswerIdUsingGet()
  if (res.data.code === 0) {
    uuid.value = res.data.data;
  } else {
    message.error("获取唯一id失败，" + res.data.message);
  }
};
// 进入页面后，生成唯一id
watchEffect(() => {
    generateUUID();
});
// watchEffect(() => {
//   if (current.value === 1) {
//     generateUUID();
//   }
// });

/**
 * 加载数据
 */
const loadData = async () => {
  if (!props.appId) {
    return;
  }
  // 获取 app
  let res: any = await getAppVoByIdUsingGet({
    id: props.appId as any,
  });
  if (res.data.code === 0) {
    app.value = res.data.data as any;
  } else {
    message.error("获取应用失败，" + res.data.message);
  }
  // 获取题目
  res = await listQuestionVoByPageUsingPost({
    appId: props.appId as any,
    current: 1,
    pageSize: 1,
    sortField: "createTime",
    sortOrder: "descend",
  });
  if (res.data.code === 0 && res.data.data?.records) {
    questionContent.value = res.data.data.records[0].questionContent;
  } else {
    message.error("获取题目失败，" + res.data.message);
  }
};

// 获取旧数据
watchEffect(() => {
  loadData();
});

// 改变 current 题号后，会自动更新当前题目和答案
watchEffect(() => {
  currentQuestion.value = questionContent.value[current.value - 1];
  currentAnswer.value = answerList[current.value - 1];
});

/**
 * 选中选项后，保存选项记录
 * @param value
 */
const doRadioChange = (value: string) => {
  answerList[current.value - 1] = value;
};

/**
 * 提交
 */
const doSubmit = async () => {
  if (!props.appId || !answerList) {
    return;
  }
  submitting.value = true;
  const res = await addUserAnswerUsingPost({
    appId: props.appId as any,
    choices: answerList,
    id: uuid.value as any,
  });
  if (res.data.code === 0 && res.data.data) {
    router.push(`/answer/result/${res.data.data}`);
  } else {
    message.error("提交答案失败，" + res.data.message);
  }
  submitting.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createElementVNode("h1", null, _toDisplayString(app.value.appName), 1),
        _createElementVNode("p", null, _toDisplayString(app.value.appDesc), 1),
        _createElementVNode("h2", _hoisted_2, _toDisplayString(current.value) + "、" + _toDisplayString(currentQuestion.value?.title), 1),
        _createElementVNode("div", null, [
          _createVNode(_component_a_radio_group, {
            direction: "vertical",
            modelValue: currentAnswer.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentAnswer).value = $event)),
            options: questionOptions.value,
            onChange: doRadioChange
          }, null, 8, ["modelValue", "options"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_a_space, { size: "large" }, {
            default: _withCtx(() => [
              (current.value < questionContent.value.length)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "primary",
                    circle: "",
                    disabled: !currentAnswer.value,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (current.value += 1))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 下一题 ")
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true),
              (current.value === questionContent.value.length)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    type: "primary",
                    loading: submitting.value,
                    circle: "",
                    disabled: !currentAnswer.value,
                    onClick: doSubmit
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(submitting.value ? "评分中" : "查看结果"), 1)
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled"]))
                : _createCommentVNode("", true),
              (current.value > 1)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 2,
                    circle: "",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (current.value -= 1))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 上一题 ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})